export class SeparationOfDutyRole {
  separationOfDutyRoleId: number;
  name?: string;
}
